import { useParams } from 'react-router-dom';
import JobsheetDetail from "../../components/Jobsheet/JobsheetDetail";
import Layout from '../../layout/default';
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

const Jobsheet = () => {

  let { id } = useParams();

  return (

    <Layout title="Clients" content="container">
    
    <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>
      <Breadcrumb.Item><Link to={`/job-sheets/`}>Job Sheets </Link></Breadcrumb.Item>      
      <Breadcrumb.Item active>Job Details</Breadcrumb.Item>
    </Breadcrumb>

    <JobsheetDetail taskid={id} />

    </Layout>
  
  )
}

export default Jobsheet